import styled from 'styled-components';

export const StyledNoteTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: #777777;
`;
